import { getSportingChatURL } from 'services/sporting/utils/getSportingURL';
import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';
import { createQueryString } from 'utils/createQueryString';
import {
  SportingAnswerDraft,
  SportingPagedResponse,
  SportingSecureParams,
  SportingAnswerDraftSortableField,
  SportingSortOrder
} from 'services/sporting/types';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

type Payload = {
  page: number;
  size: number;
  sortBy: SportingAnswerDraftSortableField;
  order: SportingSortOrder;
};

export const getAnswerDraftPage = async (
  params: SportingSecureParams<Payload>
): Promise<SportingPagedResponse<SportingAnswerDraft>> => {
  const { payload } = params;

  const endpointURL = getSportingChatURL(
    `getAnswerDraftPage?${createQueryString(payload)}`
  );

  const headers = createSportingHeaders();

  const response = await customFetch(endpointURL, {
    headers
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }

  if (response.status === 200) {
    return response.json();
  }

  return {
    content: [],
    page: 0,
    size: 0,
    totalElements: 0,
    totalPages: 0,
    last: true
  };
};
